<template>
    <div :class="['login_box', isJf? 'isJf': '', isFix? 'isFix': '']">
        <div class="home_btn">
            <a v-if="!isJf" href="/"></a>
            <a href="javascript:;" @click="closePage"></a>
        </div>
        <div class="userUnlogin">
            <a
                v-if="userAvatar && userId"
                :href="isJump? `/ucenter/index/`: 'javascript:;'"
                class="user_avatar"
            >
                <img v-if="isJf" :src="userAvatar" />
                <img v-else :src="userAvatar" alt />
                <span v-if="isJf">个人中心</span>
            </a>
            <a
                v-else
                :href="`/up/jf_login`"
            >
                <img v-if="isJf" src="https://cdncos.aigupiao.com/assets/pc/img/2023/jf_p1.svg" />
                <img v-else src="https://cdncos.aigupiao.com/assets/wap/img/icon_wap_nologin_avatar.png" />
                <span v-if="isJf">请先登录</span>
            </a>
        </div>
    </div>
</template>
<script>
export default {
    name: 'wapHeaderNew',
    components: {},
    data() {
        return {
            randomStr: Math.random().toString(36).slice(-4),
            origin: "",
            isJf: false,
            isFix: false,
            pageHref: "/login/index/rd/980880418.html",
            userAvatar: "",
            userId: "",
            isJump: true
        };
    },
    created() {
        let current = "";
        if(location.origin.indexOf("dev") > -1) {
            current = "dev"
        }
        this.origin = "https://mobile" + current + ".aigupiao.com"

        let originName = location.origin
        if(originName.indexOf("jfinfo.com") > -1 || true) {
            this.isJf = true;
        }
        if(location.pathname.indexOf("/up/mes/") > -1) {
            this.isFix = true;
        }
        if(location.pathname == '/ucenter/index/') {
            this.isJump = false
        }
    },
    watch: {
        "$store.state.user": {
            immediate: true,
            deep: true,
            handler(val) {
                if(val.avatarImgPath) {
                    this.userAvatar = val.avatarImgPath;
                }
                if(val.userId) {
                    this.userId = val.userId;
                }
            },
        },
    },
    computed: {
        // userAvatar() {
        //     return this.$store.state.user.avatarImgPath
        // },
        // userId() {
        //     return this.$store.state.user.userId
        // }
    },
    mounted() {
        this.pageHref = this.pageHref + '?redirect=' + encodeURIComponent(location.href)
    },
    methods: {
        // 判断环境
        isWechat() {
            var ua = window.navigator.userAgent.toLowerCase();
            if (ua.match(/micromessenger/i) == 'micromessenger') { // 判断是否在微信浏览器内
                return true;
            } else {
                return false;
            }
        },
        // 微信内置浏览器关闭
        closePageWx() {
            // isWechat是我写的一个判断当前环境是否是微信内置浏览器 的方法
            if (!this.isWechat()) return // 非微信环境下，不做处理 
            setTimeout(function() {
                if (typeof WeixinJSBridge == "object" && typeof WeixinJSBridge.invoke == "function") {
                    WeixinJSBridge.invoke('closeWindow', {}, function(res) {
                        if (res.err_msg == "close_window:ok") {
                            // 关闭成功的处理
                            console.log('关闭成功的处理')
                        } else {
                            // 关闭失败的处理
                            console.log('关闭失败的处理')
                        }
                    });
                }
            }, 100);
        },
        //关闭页面
        closePage() {
            history.back()
            return
            if ((navigator.userAgent.indexOf('Firefox') != -1 || navigator.userAgent.indexOf('Chrome') != -1) && !this.isWechat()) {
                console.log('Firefox或者Chrome浏览器');
                window.location.href = 'about:blank'
                window.close()
            } else if (this.isWechat()) {
                console.log('微信内置浏览器');
                this.closePageWx()
            } else {
                console.log('其他浏览器');
                window.location.href = 'about:blank'
                window.close()
            }
        },
    }

};
</script>
<style lang="css" scoped>
* {
    font-family: "PingFangSC-Regular", "PingFangSC-Light", "PingFang SC", sans-serif, "Microsoft YaHei";
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    margin: 0;
    padding: 0;
    list-style: none;
}

a {
    color: #333;
    text-decoration: none;
    /* 清除样式 ，每个网页都一样，基础文件 */
}
</style>

<style lang="less" scoped>
.login_box {
    height: 58px;
    width: 100%;
    display: flex;
    padding: 0 13px 0 15px;
    justify-content: space-between;
    box-sizing: border-box;
    align-items: center;

    &.isFix {
        position: fixed;
        color: #1A1A1A;
        z-index: 999;
        top: 0;
        width: 100%;
        height: 40px!important;
        background: #ffffff!important;
        border-bottom: 1px solid #dfdfdf;
    }

    &.isJf {
        height: 40px!important;
        background: #ffffff!important;

        .home_btn{
            width: 20px!important;
            height: 20px!important;
            background-image: url(https://cdncos.aigupiao.com/assets/pc/img/2023/jf_4.svg)!important;
            background-size: 100%;
        }
    
    
        .userUnlogin{
            border: none!important;
            width: 84px!important;
            height: 21px!important;
            border-radius: unset!important;
            >a{
                width: 84px!important;
                height: 21px!important;
                display: flex!important;
                border-radius: unset!important;
                border: none!important;
                align-items: center;
                justify-content: space-between;
                img{
                    width: 21px!important;
                    height: 21px!important;
                    border-radius: 50%;
                    margin-top: 1px;
                }
                //border-radius: unset!important;
                span{
                    font-size: 15px;
                    color:#333333;
                    line-height: 21px;
                }
            }
        }
    }
    
    > .home_btn {
        width: 25px;
        height: 21px;
        background-image: url(https://cdncos.aigupiao.com/assets/wap/img/icon_wap_home.png);
        background-size: 100%;
        > a {
            display: block;
            width: 100%;
            height: 100%;
        }
    }

    .userUnlogin {
        width: 29px;
        height: 29px;
        overflow: hidden;
        border-radius: 50%;

        > a {
            display: block;
            width: 100%;
            height: 100%;
            > img {
                width: 100%;
                height: 100%;
            }
            &.user_avatar {
                width: 27px;
                height: 27px;
                border-radius: 50%;
                box-sizing: border-box;
                border: 1px solid #cccccc;
                overflow: hidden;
            }
        }
    }
}
</style>